import { render } from "./StatisticsTwo.vue?vue&type=template&id=16510fc6&scoped=true&ts=true"
import script from "./StatisticsTwo.vue?vue&type=script&lang=ts"
export * from "./StatisticsTwo.vue?vue&type=script&lang=ts"

import "./StatisticsTwo.vue?vue&type=style&index=0&id=16510fc6&lang=scss&scoped=true"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16510fc6"]])

export default __exports__